import React, { Component } from "react";
import { PureComponent } from "react";
import Swiper from "react-id-swiper";

class PlayerGraph extends PureComponent {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
  }

  searchMatchDayIndex = (matches, currMD) => {
    let matchDay = matches;
    let slideToMd = 0;
    let fixturesNotFound = false;
    for (let i = 0; i < matchDay.length; i++) {
      if (matchDay[i].mdId === currMD.mdId) {
        fixturesNotFound = true;
        slideToMd = i;
        break;
      }
    }

    if (fixturesNotFound) {
      return slideToMd;
    } else {
      return matchDay.length - 1;
    }
  };

  render() {
    let { matchDays, currMatchDay, config, getTrans, trans, isLiveMatch } =
      this.props;
    let player = this.props.player;
    const params = {
      slidesPerView: "auto",
      // freeMode: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      initialSlide: this.searchMatchDayIndex(matchDays, currMatchDay),
    };

    return (
      <div className="si-pts__graph si-bg--plyr-card">
        <Swiper {...params}>
          {matchDays.map((md, index) => {
            let barClass = (
              currMatchDay.mdId ? md.mdId === currMatchDay.mdId : index === 0
            )
              ? "si-per-day-data si-current"
              : "si-per-day-data";
            let screenMode = this.props.screenMode;
            let isMatchLiveIncreateTeam = !isLiveMatch && md.matchStatus == "1";
            if (md.matchStatus === "0" || isMatchLiveIncreateTeam) {
              barClass = barClass + " si-img-view";
            }

            let graphClass =
              md.points.tPoints < 0
                ? "si-graph__wrap si-graph--negative"
                : "si-graph__wrap";
            const postMatchNotPlayed =
              md.stats && md.stats.oF <= 0 && +md.matchStatus === 2;
            graphClass = postMatchNotPlayed ? "si-graph__wrap" : graphClass;
            let TID = player.tId;
            let oppID =
              TID.toString() === md.atId.toString() ? md.htCCode : md.atCCode;
            let atId =
              oppID == "TBC"
                ? config.playerImgBase +
                  "/flags/" +
                  oppID +
                  ".png?v=" +
                  config.WebConfig.playerjerseyteamversion
                : config.WebConfig.END_POINT_TEAM_IMAGE +
                  oppID +
                  ".png?v=" +
                  config.WebConfig.playerjerseyteamversion;
            let barHeightStyle, insideGraph, outsideGraph;
            if (md.points.tPoints < 0) {
              // negative bar
              barHeightStyle = {};
              insideGraph = <span>{md.points.tPoints}</span>;
              outsideGraph = "";
            } else {
              // positive bar
              if (md.totalPointPercent < 25) {
                barHeightStyle =
                  md.totalPointPercent === 0
                    ? { height: "2px" }
                    : { height: md.totalPointPercent + "%" };
                insideGraph = "";
                outsideGraph = (
                  <div className="si-outnum">
                    <span>{md.points.tPoints}</span>
                  </div>
                );
              } else {
                barHeightStyle = { height: md.totalPointPercent + "%" };
                insideGraph = <span>{md.points.tPoints}</span>;
                outsideGraph = "";
              }
            }
            insideGraph = postMatchNotPlayed ? (
              <i className="euro-suspended"></i>
            ) : (
              insideGraph
            );
            outsideGraph = postMatchNotPlayed ? "" : outsideGraph;
            return (
              <div
                className={barClass}
                key={md.mdId}
                onClick={() => {
                  this.props.onGraphClick(md);
                }}
              >
                <div className={graphClass}>
                  {md.matchStatus === "0" || isMatchLiveIncreateTeam ? (
                    <div className="si-img-wrap">
                      <img src={atId} />
                    </div>
                  ) : postMatchNotPlayed ? (
                    insideGraph
                  ) : (
                    <React.Fragment>
                      {outsideGraph}
                      <div className="si-graph__bar" style={barHeightStyle}>
                        {insideGraph}
                      </div>
                    </React.Fragment>
                  )}
                </div>
                <div className="si-md">
                  {getTrans(trans, "md", "MD")}
                  {md.mdId}
                </div>
              </div>
            );
          })}
        </Swiper>
      </div>
    );
  }
}

export default PlayerGraph;
